import React, { Component } from 'react';

import ClickNHold from 'react-click-n-hold';

export default class MetricsCardItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            // iconIcon: (this.props.isMetric ? 'trending_up' : 'location_on'),
            iconIcon: 'location_on',
            isSelected: false,
            pendoIcon: 'location'
        }
        if (this.props.screenContext.screen === 'allemps' || this.props.screenContext.screen === 'emps') {
            this.state.iconIcon = 'person';
            this.state.pendoIcon = 'employee'
        } else if (this.props.isMetric) {
            this.state.iconIcon = 'trending_up';
            this.state.pendoIcon = 'metric'
        } else if (this.props.screenContext.screen === 'dists') {
            this.state.iconIcon = 'location_city';
            this.state.pendoIcon = 'districts'
        } else {
            this.state.iconIcon = 'location_on'
            this.state.pendoIcon = 'location'
        }

        if (!this.props.isMetric) {
            for (var i = 0; i < this.props.selectedItems.length; i++) {
                if (this.props.selectedItems[i].name === this.props.identity.name) {
                    this.state.isSelected = true;
                    this.state.iconIcon = 'flag';
                }
            }
        }

        this.mouseStartX = null;
        this.mouseStartY = null;
        this.mouseX = null;
        this.mouseY = null;

        this.numberWithCommas = this.numberWithCommas.bind(this);
        this.convertToDisplay = this.convertToDisplay.bind(this);

        this.handleStartIdenityPress.bind(this);
        this.handleEndIdenityPress.bind(this);

        this.identityHoldStart = this.identityHoldStart.bind(this);
        this.identityHoldGo = this.identityHoldGo.bind(this);
        this.identityHoldEnd = this.identityHoldEnd.bind(this);
        this.identityHoldListener = this.identityHoldListener.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {
        if (!this.state.isSelected) {
            if (this.props.screenContext.screen === 'allemps' || this.props.screenContext.screen === 'emps') {
                this.setState({ iconIcon: 'person', pendoIcon:'employee' });
            } else if (this.props.isMetric) {
                this.setState({ iconIcon: 'trending_up', pendoIcon:'metric' });
            } else if (this.props.screenContext.screen === 'dists') {
                this.setState({ iconIcon: 'location_city', pendoIcon:'districts' });
            } else {
                this.setState({ iconIcon: 'location_on', pendoIcon:'location' });
            }
        }
    }

    componentWillUnmount() {

    }

    numberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    convertToDisplay(type, startText, number) {

        let endText = startText;
        switch (type) {
            case 'MNY':
                if (this.props.isSideBySide) {
                    number = Math.floor(parseFloat(number));
                }
                endText += '$' + this.numberWithCommas(number);
                break;
            case 'INT':
                let newNum = parseFloat(number);
                if (newNum === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(0));
                }
                break;
            case 'PCT':
                let newNum1 = parseFloat(number);
                if (newNum1 === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(1)) + '%';
                }
                break;
            default:
                endText += this.numberWithCommas(number);
        }
        return endText;
    }


    handleStartIdenityPress(name, event) {
        let self = this;
    }

    handleEndIdenityPress() {
        if (this.identiyLogPressTimeout !== undefined) {
            clearTimeout(this.identiyLogPressTimeout);
            this.identiyLogPressTimeout = undefined;
        }
    }

    identityHoldStart(e) {
        if (e.touches != undefined && e.touches != null && e.touches.length > 0) {
            this.mouseStartX = e.touches[0].clientX;
            this.mouseStartY = e.touches[0].clientY;
            this.mouseX = e.touches[0].clientX;
            this.mouseY = e.touches[0].clientY;

            document.documentElement.addEventListener('touchmove', this.identityHoldListener);
        }
    }
    identityHoldGo() {
        if (this.mouseX != null && this.mouseStartX != null && this.mouseY != null && this.mouseStartY != null &&
            this.mouseX <= this.mouseStartX + 2 && this.mouseX >= this.mouseStartX - 2 && this.mouseY <= this.mouseStartY + 2 && this.mouseY >= this.mouseStartY - 2) {
            // this.props.changeScreenLong(undefined, this.props.identity.storeId);
            this.props.promptForLongData(this.props.identity);
        }
    }
    identityHoldEnd(e) {
        document.documentElement.removeEventListener('touchmove', this.identityHoldListener);
        this.mouseStartX = null;
        this.mouseStartY = null;
        this.mouseX = null;
        this.mouseY = null;
    }

    identityHoldListener(e) {
        if (e.touches != undefined && e.touches != null && e.touches.length > 0) {
            this.mouseX = e.touches[0].clientX;
            this.mouseY = e.touches[0].clientY;
        }
    }

    render() {
        let identity = this.props.identity;
        let range = this.props.range;
        let propertyName = "name";
        if (this.props.isMetric) {
            propertyName = "kPIName";
        }
        let cDataDTotal = 0;
        let cDataTotal = 0;
        let totalTopText = "";
        let totalBottomText = "";
        let totalTopTextClass = 'metrics-card-numbers-top';
        let totalBottomTextClass = 'metrics-card-numbers-bottom';
        if (identity != undefined && identity.cData != undefined &&
            identity.lDataD != undefined) {

            if (identity.lDataD[range] != undefined) {
                // cDataDTotal = identity.lDataD[range].toFixed(2);
                cDataDTotal = identity['lData' + (this.props.dataMode === 'N' ? '' : this.props.dataMode)][range].toFixed(2);
                if (this.props.dataMode != 'N') {
                    totalTopText += (cDataDTotal >= 0 ? '+' : '-');
                }
                if (this.props.dataMode != 'P') {
                    if (this.props.dataMode === 'D' && identity.type === 'PCT') {
                        totalTopText += Math.abs(cDataDTotal).toFixed(1);
                    } else {
                        totalTopText = this.convertToDisplay(identity.type, totalTopText, Math.abs(cDataDTotal).toFixed(2));
                    }
                } else {
                    totalTopText += Math.abs(cDataDTotal).toFixed(1) + '%';
                }
                totalTopTextClass += ((identity['lDataD'][range] >= 0 && identity.sign === '') || (identity['lDataD'][range] <= 0 && identity.sign === '-') ? '' : ' metrics-card-numbers-top--negative');

                if (this.props.isSideBySide) {
                    totalBottomTextClass += ((identity['lDataD'][range] >= 0 && identity.sign === '') || (identity['lDataD'][range] <= 0 && identity.sign === '-') ? '' : ' metrics-card-numbers-top--negative');
                }
            }
            if (identity.cData[range] != undefined) {
                cDataTotal = identity.cData[range].toFixed(2);
                totalBottomText = this.convertToDisplay(identity.type, totalBottomText, cDataTotal);
            }
        }

        let isSelected = false;
        if (!this.props.isMetric) {
            for (var i = 0; i < this.props.selectedItems.length; i++) {
                if (this.props.selectedItems[i].name === identity.name) {
                    isSelected = true;
                }
            }
        }

        let iconClass = 'material-icons metrics-card-item-icon';
        let iconIcon = 'location_on';
        let pendoIcon = 'location';
        if (this.props.screenContext.screen === 'allemps' || this.props.screenContext.screen === 'emps') {
            iconIcon = 'person';
            pendoIcon = 'employee';
        } else if (this.props.screenContext.screen === 'dists') {
            iconIcon = 'location_city';
            pendoIcon = 'districts';
        } else if (this.props.isMetric) {
            iconIcon = 'trending_up';
            pendoIcon = 'metric';
        }
        if (isSelected != this.state.isSelected) {
            var self = this;
            iconClass += ' metrics-card-item-icon-hidden';
            setTimeout(() => {
                if (self.state.isSelected != isSelected) {

                    if (isSelected) {
                        iconIcon = 'flag';
                    }

                    self.setState({ isSelected: isSelected, iconIcon: iconIcon });
                }
            }, 125);
        }

        if (isSelected) {
            iconClass += ' metrics-card-item-icon-selected';
        }

        let outerClass = 'metrics-card-item-outer';
        if (this.props.isSideBySide) {
            outerClass += ' metrics-card-item-outer-sidebyside';
        }
        if (this.props.isClipboard) {
            outerClass += ' metrics-card-item-clipboard'
        }

        let isMe = false;
        let isBlurred = false;

        if (this.props.accountInfo != undefined && this.props.accountInfo != null && this.props.accountInfo.userType === 5) {
            isMe = identity.userId === this.props.accountInfo.userId;
            isBlurred = this.props.accountInfo.isEmployeeBlurred === null ? false : this.props.accountInfo.isEmployeeBlurred;
        }

        let leftJsx = null;
        let centerJsx = null;
        if (this.props.screenContext.screen === 'allemps' || this.props.screenContext.screen === 'emps') {

            let onlineClass = "metrics-card-item-icon-online";
            if (identity.isWorking) {
                onlineClass += ' metrics-card-item-icon-online--active background-emerald';
            }

            let onlineStyle = {}
            if (this.props.workingFlag) {
                //onlineStyle.opacity = '1';
            }

            let empNameJsx = isBlurred && !isMe ?
                (<div className="metrics-card-name-person text-blurred">{"Jane Smith"}</div>)
                :
                (<div className="metrics-card-name-person">{identity[propertyName]}</div>);

            let empLocationJsx = isBlurred && !isMe ?
                (<div className="metrics-card-subname-person text-blurred">{"Unknown Location"}</div>)
                :
                (<div className="metrics-card-subname-person">{identity.locationName}</div>);

            let avatarImage = (isBlurred && !isMe) || (identity.avatarUrl === undefined || identity.avatarUrl === null) ?
                <div className={iconClass}>{this.state.iconIcon}</div>
                :
                (<div className={iconClass}>{this.state.iconIcon}<img className="avatar-image" src={identity.avatarUrl} onError={(e) => { e.target.style.display = 'none' }} style={{ opacity: this.state.iconIcon === 'flag' ? '0.25' : '1' }} /></div>);

            leftJsx = (
                <div key={'icon-' + identity.uId} onClick={this.props.toggleSelectedItem.bind(null, this.props.identity)} className="metrics-card-item-icon-container">
                    {avatarImage}
                    <div className={onlineClass} style={onlineStyle}></div>
                </div>
            );
            centerJsx = (
                <div key={'name-' + identity.uId} className="metrics-card-name-container" id={'center-' + identity.uId}
                    onClick={this.props.changeScreen.bind(null, identity[propertyName])}>
                    {empNameJsx}
                    {empLocationJsx}
                </div>
            );
        } else if (this.props.screenContext.screen === 'locs' || this.props.screenContext.screen === 'distLocs') {
            leftJsx = (
                <div key={'icon-' + identity.uId} onClick={this.props.toggleSelectedItem.bind(null, this.props.identity)} className="metrics-card-item-icon-container">
                    <div className={iconClass}>{this.state.iconIcon}</div>
                </div>
            );
            centerJsx = (
                this.props.hasDistricts ?
                    (
                        <div key={'name-' + identity.uId} className="metrics-card-name-container" id={'center-' + identity.uId}
                            onClick={this.props.changeScreen.bind(null, identity[propertyName])}>
                            <div className="metrics-card-name-person">{identity[propertyName]}</div>
                            <div className="metrics-card-subname-person">{this.props.isGroupsMode ? identity.clientAccountName : identity.districtName}</div>
                        </div>
                    ) : (
                        <div key={'name-' + identity.uId} className="metrics-card-name-container" id={'center-' + identity.uId}
                            onClick={this.props.changeScreen.bind(null, identity[propertyName])}>
                            <div className="metrics-card-name">{identity[propertyName]}</div>
                        </div>
                    )
            );
        } else {
            leftJsx = (
                <div key={'icon-' + identity.uId} onClick={this.props.toggleSelectedItem.bind(null, this.props.identity)} className="metrics-card-item-icon-container">
                    <div className={iconClass}>{this.state.iconIcon}</div>
                </div>
            );
            centerJsx = (
                <div key={'name-' + identity.uId} className="metrics-card-name-container" id={'center-' + identity.uId}
                    onClick={this.props.changeScreen.bind(null, identity[propertyName])}>
                    <div className="metrics-card-name">{identity[propertyName]}</div>
                </div>
            );
        }

        let spanClass = "metrics-card-numbers-bottom-icon"
        let spanContent = "";
        switch (zzDataCache.settings.compareMode) {
            case 'lastYear': spanContent = "LY"; spanClass += " text"; break;
            case 'endOfLastPeriod': spanContent = "LP"; spanClass += " text"; break;
            case 'toDateLastPeriod': spanContent = "LP"; spanClass += " text"; break;
            case 'thisDayLastPeriod': spanContent = "LP"; spanClass += " text"; break;
            case 'targets': spanContent = "gps_fixed"; spanClass = "material-icons " + spanClass; break;
            default: spanClass += ' hidden';
        }

        return (
            <div data-trackid={ this.props.isMetric ?'metrics-card-'+this.state.pendoIcon + '-' + identity[propertyName].split(' ').join('') : 'metrics-card-'+this.state.pendoIcon} className={outerClass}>
                {leftJsx}
                <ClickNHold
                    className={"metrics-card-click-n-hold"}
                    time={0.5}
                    onStart={this.identityHoldStart}
                    onClickNHold={this.identityHoldGo}
                    onEnd={this.identityHoldEnd}
                >
                    {centerJsx}
                </ClickNHold>
                <div key={'numbers-' + identity.uId} className="metrics-card-numbers-container" onClick={this.props.rotateDataMode}>
                    <div className={totalTopTextClass}>{totalBottomText}</div>
                    <div className={totalBottomTextClass}>{totalTopText}<span className={spanClass}>{spanContent}</span></div>
                </div>
            </div>
        );
    }
}